module.exports = __webpack_public_path__ + "img/home_swiper_03.e7af9e03.jpg";